<script setup lang="ts">
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.scss'
import BackgroundContainer from "@/components/Background/BackgroundContainer.vue";
import PaymentResult from "@/components/Common/PaymentResult.vue";
</script>

<script lang="ts">
import {defineComponent} from "vue";
import store from "@/store";

export default defineComponent({
    data(): {
        fontUrl: string
    } {
        return {
            fontUrl: `url('/font/Storopia.woff2') format("woff2"), url('/font/Storopia.ttf')  format('truetype'), url('/font/Storopia.woff') format('woff')`,
        }
    },

    methods: {
        updateSize(): void
        {
            store.state.pageSize.width = window.innerWidth
            store.state.pageSize.height = window.innerHeight
        },
    },

    mounted(): void
    {
        this.updateSize()

        window.addEventListener('resize', this.updateSize)

        document.addEventListener('mousemove', (event) => {
            store.state.cursor.x = event.clientX
            store.state.cursor.y = event.clientY
        })
    },
})
</script>

<template>
    <BackgroundContainer/>

    <PaymentResult/>

    <RouterView v-slot="{ Component, route }">
        <Transition :name="route.meta.transition || 'fade'" mode=out-in>
            <component :is="Component"/>
        </Transition>
    </RouterView>
</template>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.slide-top-enter-active {
    transition: all 0.3s ease-out;
}

.slide-top-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-top-enter-from,
.slide-top-leave-to {
    transform: translateY(-55px);
    opacity: 0;
}
</style>

<style lang="scss">
body {
    background: black;
    margin: 0;
    padding: 0;

    //font-family: Storopia, Arial !important;
    font-family: Storopia !important;
}

div {
    position: relative;
}

.w-fit-content {
    width: fit-content;
}

.gap-6 {
    gap: 3.5rem !important;
}

.gap-7 {
    gap: 4rem !important;
}

.gap-8 {
    gap: 4.5rem !important;
}

@font-face {
    font-family: Storopia;
    src: v-bind('fontUrl');
    src:    url('https://cdn.scouts.su/font/Storopia.woff2') format("woff2"),
            url('https://cdn.scouts.su/font/Storopia.ttf')  format('truetype'),
            url('https://cdn.scouts.su/font/Storopia.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: auto;
}

@font-face {
    font-family: Furore;
    src:    url('https://cdn.scouts.su/font/Furore.otf') format("otf"),
    url('https://cdn.scouts.su/font/Furore.woff2') format("woff2");
    font-weight: normal;
    font-style: normal;
    font-display: auto;
    /* Furore не умеет Unicode-пробелы (NBSP / узкий NBSP); ru-локаль ставит ими разряды. */
    unicode-range: U+0000-009F, U+00A1-1FFF, U+200C-202E, U+2030-205E, U+2060-10FFFF;
}

#app {
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.noselect {
    -webkit-touch-callout: none !important;
    -webkit-user-select: none !important;
    -khtml-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
}

.absolute-fill {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.text-wheat {
    color: #dcb263;
}

.font-furore {
    font-family: Furore, sans-serif;
}

.fs-rem-1 {
    font-size: 0.65rem;
}

.fs-rem-2 {
    font-size: 0.65rem;
}

.fs-rem-3 {
    font-size: 0.7rem;
}

.fs-rem-4 {
    font-size: 0.75rem;
}

.fs-rem-5 {
    font-size: 0.8rem;
}

.fs-rem-6 {
    font-size: 0.85rem;
}

.fs-rem-7 {
    font-size: 0.9rem;
}

.fs-rem-8 {
    font-size: 0.95rem;
}

.fs-rem-9 {
    font-size: 1.0rem;
}

.fs-rem-10 {
    font-size: 1.05rem;
}

.fs-rem-11 {
    font-size: 1.1rem;
}

@keyframes lightning-pulse {
    0% {
        filter: drop-shadow(0 0 5px rgba(255, 193, 7, 0.2))
        drop-shadow(0 0 15px rgba(255, 152, 0, 0.2))
        drop-shadow(0 0 25px rgba(255, 193, 7, 0.1))
        drop-shadow(0 0 8px rgba(255, 87, 34, 0.15));
    }
    50% {
        filter: drop-shadow(0 0 10px rgba(255, 190, 76, 0.4))
        drop-shadow(0 0 30px rgba(255, 190, 76, 0.3))
        drop-shadow(0 0 50px rgba(255, 80, 76, 0.12))
        drop-shadow(0 0 15px rgba(255, 190, 76, 0.25));
    }
    100% {
        filter: drop-shadow(0 0 5px rgba(255, 193, 7, 0.2))
        drop-shadow(0 0 15px rgba(255, 152, 0, 0.2))
        drop-shadow(0 0 25px rgba(255, 193, 7, 0.1))
        drop-shadow(0 0 8px rgba(255, 87, 34, 0.15));
    }
}

@keyframes lightning-color {
    0% {
        fill: #ffd555;
    }
    50% {
        fill: #ffff8d;
    }
    100% {
        fill: #ffd555;
    }
}
</style>
